module.exports = __webpack_public_path__ + "img/menu-hamburguer.5f758649.svg";